import { Button, Tabs, Tab, Select, MenuItem, FormControl, InputLabel, IconButton } from '@mui/material';
import ReportsBase from './ReportsBase';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import '../App.css';
import { DownloadForOffline, History } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';

function Reports() {
    //const [financials, setFinancials] = useState([{}]);
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedPeerGroup, setSelectedPeerGroup] = useState('');
    const [selectedPeerGroupName, setSelectedPeerGroupName] = useState('');
    const [peerGroups, setPeerGroups] = useState([]);
    const [fiscalFinancials, setFiscalFinancials] = useState([{}]);
    const [ytdFinancials, setYtdFinancials] = useState([{}]);
    const reportCount = 8;

    // Generate array of last 5 years
    const years = Array.from({length: 5}, (_, i) => new Date().getFullYear() - i);

    // Split financials into YTD and non-YTD
    //const ytdFinancials = financials?financials.filter(f => f.isYTD):[{}];
    //const fiscalFinancials = financials?financials.filter(f => !f.isYTD):[{}];

    // Fetch peer groups that user can view
    useEffect(() => {
        axios({
            url: process.env.REACT_APP_API_URL + 'PeerGroup',
            method: "Get",
        }).then((res) => {
            setPeerGroups(res.data);
            // Set first peer group as default if available
            if (res.data.length > 0) {
                setSelectedPeerGroup(res.data[0].peerGroupId);
                setSelectedPeerGroupName(res.data[0].peerName);
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    useEffect(() => {
        // Only fetch if peerGroupId is available
        if (!selectedPeerGroup) return;
        
        axios({
            url: process.env.REACT_APP_API_URL + `FiscalReport?year=${selectedYear}&peerGroupId=${selectedPeerGroup}`,
            method: "Get",
            data: {},
        }).then((res) => {
            //Create two arrays, one for fiscal year and one for ytd
            const arrFiscalFinancials = [];
            const arrYtdFinancials = [];
            //Sort the data into those two arrays
            res.data.forEach(f => {
                if (f.isYTD) {
                    arrFiscalFinancials.push(f);
                } else {
                    arrYtdFinancials.push(f);
                }
            });
            const divisionGroups = [];
            res.data.forEach(f => {
                const division = f.division;
                if (!divisionGroups.includes(division)) {
                    divisionGroups.push(division);
                }
            });
            
            const sortedFiscalFinancials = [];
            const sortedYtdFinancials = [];
            //Now for each in fiscalFinancials, group by division and then sort by company name
            divisionGroups.forEach(division => {
                const divisionData = arrFiscalFinancials.filter(f => f.division === division);
                const sortedDivisionData = divisionData.sort((a, b) => (a.companyName || '').localeCompare(b.companyName || ''));
                for (let i = 0; i < sortedDivisionData.length; i++) {
                    sortedFiscalFinancials.push(sortedDivisionData[i]);
                }
            });

            //Now for each in ytdFinancials, group by division and then sort by company name
            divisionGroups.forEach(division => {
                const divisionData = arrYtdFinancials.filter(f => f.division === division);
                const sortedDivisionData = divisionData.sort((a, b) => (a.companyName || '').localeCompare(b.companyName || ''));
                for (let i = 0; i < sortedDivisionData.length; i++) {
                    sortedYtdFinancials.push(sortedDivisionData[i]);
                }
            });
            
            console.log(sortedFiscalFinancials);
            setFiscalFinancials(sortedFiscalFinancials);
            setYtdFinancials(sortedYtdFinancials);
        }).catch((err) => {
            console.log(err)
        });
    }, [selectedYear, selectedPeerGroup]);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        setSelectedYear(currentYear);
    }, []);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handlePeerGroupChange = (event) => {
        const selectedId = event.target.value;
        setSelectedPeerGroup(selectedId);
        
        // Find the selected peer group and set its name
        const selectedGroup = peerGroups.find(group => group.peerGroupId === selectedId);
        if (selectedGroup) {
            setSelectedPeerGroupName(selectedGroup.peerName);
        }
    };

    //Download PDF
    const dlReport = () => {
      // Use the appropriate financials based on selected tab
      const currentFinancials = selectedTab === 0 ? fiscalFinancials : ytdFinancials;

      if (currentFinancials.length === 0) {
          return 0;
      }

      let numberOfGroups = Math.floor(currentFinancials.length / reportCount);
      const fyRemainder = fiscalFinancials.length % reportCount;
      numberOfGroups += (fyRemainder > 0 ? 1 : 0);

      const doc = new jsPDF({ orientation: 'l', format: 'letter' });
      //I need to do YTD And FY
      for (let i = 0; i < numberOfGroups; i++) {
          if (i > 0) {
              doc.autoTable({
                  html: "#tblFY" + i,
                  useCss: true,
                  theme: 'plain',
                  startY: doc.lastAutoTable.finalY + 15,
                  pageBreak: 'avoid'
              });
          } else {
              doc.autoTable({ html: "#tblFY" + i, useCss: true, theme: 'plain' });
          }
      }

      const ytdRemainder = ytdFinancials.length % reportCount;
      numberOfGroups = Math.floor(ytdFinancials.length / reportCount);
      numberOfGroups += (ytdRemainder > 0 ? 1 : 0);
      console.log(ytdRemainder + " " + numberOfGroups);
      for (let i = 0; i < numberOfGroups; i++) {
        doc.autoTable({
          html: "#tblYTD" + i,
          useCss: true,
          theme: 'plain',
          startY: doc.lastAutoTable.finalY + 15,
          pageBreak: 'avoid'
          });
      }

      doc.save('testdl.pdf');
      const uri = doc.output('datauristring');
      const newTab = window.open();
      newTab?.document.write(`<iframe width='100%' height='100%' src='${uri}'></iframe>`);
  };

    const dlExcel = () => {
        // Use the appropriate financials based on selected tab
        const currentFinancials = selectedTab === 0 ? fiscalFinancials : ytdFinancials;
        
        if (!currentFinancials || currentFinancials.length === 0) {
            console.log("No financials data available");
            return;
        }
        
        try {
            // Target the correct table based on selected tab
            const tableId = selectedTab === 0 ? "tblF0" : "tblY0";
            const tableSelector = `table#${tableId}`;
            
            console.log("Looking for table with selector:", tableSelector);
            
            const table = document.querySelector(tableSelector);
            if (!table) {
                console.log("Table not found with selector:", tableSelector);
                // Try a more general approach
                const visibleTables = document.querySelectorAll('.reportTable table');
                console.log("Found visible tables:", visibleTables.length);
                if (visibleTables.length === 0) {
                    console.log("No tables found in the DOM");
                    return;
                }
                // Use the first visible table
                const tableRows = visibleTables[0].querySelectorAll('tr');
                processTableRows(tableRows);
            } else {
                const tableRows = table.querySelectorAll('tr');
                console.log("Found table rows:", tableRows.length);
                processTableRows(tableRows);
            }
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
        
        function processTableRows(tableRows) {
            if (!tableRows || tableRows.length === 0) {
                console.log("No table rows found");
                return;
            }
            
            // Extract data from the table
            const excelData = [];
            
            // Process header row specially to handle column spans
            const headerRow = tableRows[0];
            const headerCells = headerRow.querySelectorAll('th');
            const headerData = [];
            
            // First cell (Metric) doesn't span
            headerData.push(headerCells[0].textContent.trim());
            
            // For each company name in the header (every other cell starting from index 1)
            for (let i = 1; i < headerCells.length; i ++) {
                const companyName = headerCells[i].textContent.trim();
                // Add the company name twice to simulate the span
                headerData.push(companyName);
                headerData.push(companyName);
            }
            
            excelData.push(headerData);
            
            // Add a subheader row for the "%" columns
            // const subheaderData = [""];  // Empty cell for Metric column
            // for (let i = 1; i < headerCells.length; i += 2) {
            //     subheaderData.push("Value");
            //     subheaderData.push("%");
            // }
            
            // excelData.push(subheaderData);
            
            // Process the rest of the rows normally
            for (let rowIndex = 1; rowIndex < tableRows.length; rowIndex++) {
                const row = tableRows[rowIndex];
                const rowData = [];
                const cells = row.querySelectorAll('th, td');
                
                cells.forEach(cell => {
                    rowData.push(cell.textContent.trim());
                });
                
                excelData.push(rowData);
            }
            
            console.log("Excel data prepared:", excelData);
            
            if (excelData.length === 0) {
                console.log("No data extracted from table");
                return;
            }
            
            // Create workbook
            const wb = XLSX.utils.book_new();
            
            // Create worksheet from the extracted data
            const ws = XLSX.utils.aoa_to_sheet(excelData);
            
            // Add merge cells for the header row
            ws['!merges'] = [];
            for (let i = 1; i < headerData.length; i += 2) {
                ws['!merges'].push({ 
                    s: { r: 0, c: i }, 
                    e: { r: 0, c: i + 1 } 
                });
            }
            
            // Set column widths for better readability
            const colWidths = excelData[1].map(col => ({ wch: Math.max(12, col.length + 2) }));
            ws['!cols'] = colWidths;
            
            // Add worksheet to workbook
            const sheetName = selectedTab === 0 ? "Fiscal Year Report" : "YTD Report";
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
            
            // Generate Excel file and trigger download
            const fileName = selectedTab === 0 ? "fiscal_year_report.xlsx" : "ytd_report.xlsx";
            XLSX.writeFile(wb, fileName);
            
            console.log("Excel file download triggered");
        }
    };

    return (
        <>
            <div className="container" style={{ 
                maxWidth: '100%',
                overflowX: 'auto'  // Adds horizontal scroll if needed
            }}>
                <div style={{
                    padding: '20px',
                    marginBottom: '20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '20px'
                }}>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <FormControl size="small" style={{ minWidth: 120 }}>
                            <InputLabel>Year</InputLabel>
                            <Select
                                value={selectedYear}
                                label="Year"
                                onChange={handleYearChange}
                            >
                                {years.map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small" style={{ minWidth: 200 }}>
                            <InputLabel>Peer Group</InputLabel>
                            <Select
                                value={selectedPeerGroup}
                                label="Peer Group"
                                onChange={handlePeerGroupChange}
                                disabled={peerGroups.length === 0}
                            >
                                {peerGroups.map((group) => (
                                    <MenuItem key={group.peerGroupId} value={group.peerGroupId}>
                                        {group.peerName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Button 
                            variant="outlined" 
                            onClick={dlReport} 
                            size='small' 
                            startIcon={<DownloadForOffline />}
                            sx={{ mr: 1 }}
                        >
                            Download PDF
                        </Button>
                        <Button 
                            variant="outlined" 
                            onClick={dlExcel} 
                            size='small' 
                            startIcon={<DownloadForOffline />}
                        >
                            Download Excel
                        </Button>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <Tabs value={selectedTab} onChange={handleTabChange}>
                            <Tab label="YTD" />
                            <Tab label="Full Fiscal Year" />
                        </Tabs>
                        
                        <Button
                            component={Link}
                            to="/historical"
                            variant="text"
                            color="primary"
                            startIcon={<History />}
                            size="small"
                        >
                            Historical
                        </Button>
                    </div>
                </div>

                <div style={{ 
                    width: '100%',
                    overflowX: 'auto'  // Adds horizontal scroll if needed
                }}>
                    {/* Tabbed content */}
                    {selectedTab === 0 && (
                        <ReportsBase financials={fiscalFinancials} reportCount={reportCount} htmlBaseId="tblF" peerName={selectedPeerGroupName} />
                    )}
                    {selectedTab === 1 && (
                        <ReportsBase financials={ytdFinancials} reportCount={reportCount} htmlBaseId="tblY" peerName={selectedPeerGroupName} />
                    )}
                </div>
                <div>
                <ReportsBase financials={fiscalFinancials} reportCount={reportCount} htmlBaseId="tblFY" forPrint={true} peerName={selectedPeerGroupName} />
                <ReportsBase financials={ytdFinancials} reportCount={reportCount} htmlBaseId="tblYTD" forPrint={true} peerName={selectedPeerGroupName} />
                </div>
            </div>
        </>
    );
}

export default Reports;